export default {
  setRegistryProps(state, payload) {
    state.props = payload
  },
  setVehicleProps(state, payload) {
    state.props = payload
  },
}
